import React, { Component } from 'react';
import PropTypes from 'prop-types';
import HForm, { TextAreaField } from 'shared/containers/portal_layout/HForm';
import { reduxForm } from 'utils/reduxFormWrapper';
import FlashMessageActions from 'shared/actions/FlashMessageActions';
import api from 'utils/api';
import { decamelizeKeys } from 'humps';
import Errors from 'shared/components/Errors';
import SpinnerButton from 'shared/components/SpinnerButton';

class ReferralWithdrawer extends Component {
  constructor(props, context) {
    super(props, context);
    this.withdrawReferral = this.withdrawReferral.bind(this);
  }

  withdrawReferral(formValues) {
    return api
      .post(
        `${this.props.apiEndpoint}/referrals/${this.props.referralId}/withdrawals`,
        decamelizeKeys(formValues)
      )
      .then(response => {
        this.props.handleSuccess();
        FlashMessageActions.flashSuccess({
          message: 'You have successfully withdrawn this referral',
        });
      });
  }

  render() {
    return (
      <FormifiedPresentationComponent form="referralWithdraw" onSubmit={this.withdrawReferral} />
    );
  }
}

ReferralWithdrawer.propTypes = {
  apiEndpoint: PropTypes.string.isRequired,
  handleSuccess: PropTypes.func.isRequired,
};

const PresentationComponent = props => (
  <HForm onSubmit={props.handleSubmit}>
    <div className="modal-header">
      <h3>Withdraw Referral</h3>
    </div>
    <div className="modal-body" style={{ width: '600px' }}>
      <Errors errors={props.error || []} />
      <TextAreaField name="withdrawalReason" label="Withdrawal Reason" />
    </div>
    <div className="modal-footer">
      <SpinnerButton type="submit" className="btn btn-primary" loading={props.submitting}>
        Withdraw
      </SpinnerButton>
    </div>
  </HForm>
);

PresentationComponent.displayName = 'PresentationComponent';

const FormifiedPresentationComponent = reduxForm({})(PresentationComponent);

export default ReferralWithdrawer;
